import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    client: 0,
    account: 0,
    groups: 0,
    project: 0,
    task: 0,
    calendar: 0,
    timeOff: 0,
    suggestions: 0,
    push: 0,
};

const refreshTriggersSlice = createSlice({
    name: 'refreshTriggers',
    initialState,
    reducers: {
        triggerRefresh: (state, action) => {
            const { triggerName } = action.payload;
            if (triggerName in state) {
                state[triggerName] += 1;
            }
        },
    },
});

export const { triggerRefresh } = refreshTriggersSlice.actions;
export default refreshTriggersSlice.reducer;